import { render, staticRenderFns } from "./MealStatistics.vue?vue&type=template&id=cf066ec0&scoped=true&"
import script from "./MealStatistics.vue?vue&type=script&lang=js&"
export * from "./MealStatistics.vue?vue&type=script&lang=js&"
import style0 from "./MealStatistics.vue?vue&type=style&index=0&id=cf066ec0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf066ec0",
  null
  
)

export default component.exports